import ContainerLogin from "../../componets/ContainerLogin/ContainerLogin";

export default function Login() {
    return (
        <div className="App">
            <ContainerLogin/>
        </div>
    )
}